// Component: Slider.jsx
// Purpose: DS range control — an eyebrow label + a live value readout over a
//   native <input type="range">, tinted with DS tokens. Native on purpose:
//   keyboard (arrows/Home/End), touch dragging and a11y semantics come free,
//   which a div-and-pointer-events reimplementation would have to re-earn.
//   The filled portion is painted with a gradient driven by --ds-slider-pct.
//   Optional anchor captions label the two ends (e.g. Conservative → Aggressive).
//   Styling in ds-components.css (.ds-slider-*).
//
// Usage:
//   <Slider label="Risk tolerance" value={risk} min={1} max={10} suffix="/ 10"
//           onChange={(v) => setRisk(v)}
//           minLabel="Conservative" maxLabel="Aggressive" />

import React from "react";
import { cx } from "./cx";

export function Slider({
  label,
  value,
  min = 0,
  max = 10,
  step = 1,
  onChange,
  minLabel,
  maxLabel,
  suffix,
  className,
  ...props
}) {
  const num = Number(value);
  const pct = max > min ? ((num - min) / (max - min)) * 100 : 0;

  return (
    <div className={cx("ds-slider", className)}>
      {(label != null || value != null) && (
        <div className="ds-slider-top">
          {label != null && <span className="ds-slider-label">{label}</span>}
          {value != null && (
            <span className="ds-slider-value">
              {value}
              {suffix ? <span className="ds-slider-suffix">{suffix}</span> : null}
            </span>
          )}
        </div>
      )}

      <input
        type="range"
        className="ds-slider-input"
        min={min}
        max={max}
        step={step}
        value={num}
        aria-label={typeof label === "string" ? label : undefined}
        onChange={(e) => onChange?.(Number(e.target.value))}
        style={{ "--ds-slider-pct": `${pct}%` }}
        {...props}
      />

      {(minLabel || maxLabel) && (
        <div className="ds-slider-anchors">
          <span>{minLabel}</span>
          <span>{maxLabel}</span>
        </div>
      )}
    </div>
  );
}

export default Slider;
